import axios from '@/services/ProductService/productInstance'
import { notifyOnboardingStatusChanged } from '@/features/onboarding/events'


export default async function savePricing(data: any, id?: number) {
	try {
		const res = id
			? await axios.put(`/pricing/${id}`, data)
			: await axios.post(`/pricing/`, data)

		notifyOnboardingStatusChanged()
		return res.data
	} catch {
		return null
	}
}
